module.exports = __webpack_public_path__ + "static/img/1.29510e9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/11/zh/1.png
// module id = JxwN
// module chunks = 0